module.exports = __webpack_public_path__ + "static/media/cross-small.4d93ff0e.svg";